import { render, staticRenderFns } from "./HandleCustomerProblem.vue?vue&type=template&id=ead87266&scoped=true&"
import script from "./HandleCustomerProblem.vue?vue&type=script&lang=js&"
export * from "./HandleCustomerProblem.vue?vue&type=script&lang=js&"
import style0 from "./HandleCustomerProblem.vue?vue&type=style&index=0&id=ead87266&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead87266",
  null
  
)

export default component.exports